import _toConsumableArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

var f = r(),
    n = function n(e) {
  return c(e, f);
},
    m = r();

n.write = function (e) {
  return c(e, m);
};

var d = r();

n.onStart = function (e) {
  return c(e, d);
};

var h = r();

n.onFrame = function (e) {
  return c(e, h);
};

var p = r();

n.onFinish = function (e) {
  return c(e, p);
};

var i = [];

n.setTimeout = function (e, t) {
  var a = n.now() + t,
      o = function o() {
    var F = i.findIndex(function (z) {
      return z.cancel == o;
    });
    ~F && i.splice(F, 1), u -= ~F ? 1 : 0;
  },
      s = {
    time: a,
    handler: e,
    cancel: o
  };

  return i.splice(w(a), 0, s), u += 1, v(), s;
};

var w = function w(e) {
  return ~(~i.findIndex(function (t) {
    return t.time > e;
  }) || ~i.length);
};

n.cancel = function (e) {
  d.delete(e), h.delete(e), p.delete(e), f.delete(e), m.delete(e);
};

n.sync = function (e) {
  T = !0, n.batchedUpdates(e), T = !1;
};

n.throttle = function (e) {
  var t;

  function a() {
    try {
      e.apply(void 0, _toConsumableArray(t));
    } finally {
      t = null;
    }
  }

  function o() {
    for (var _len = arguments.length, s = new Array(_len), _key = 0; _key < _len; _key++) {
      s[_key] = arguments[_key];
    }

    t = s, n.onStart(a);
  }

  return o.handler = e, o.cancel = function () {
    d.delete(a), t = null;
  }, o;
};

var y = typeof window < "u" ? window.requestAnimationFrame : function () {};

n.use = function (e) {
  return y = e;
};

n.now = typeof performance < "u" ? function () {
  return performance.now();
} : Date.now;

n.batchedUpdates = function (e) {
  return e();
};

n.catch = console.error;
n.frameLoop = "always";

n.advance = function () {
  n.frameLoop !== "demand" ? console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand") : x();
};

var l = -1,
    u = 0,
    T = !1;

function c(e, t) {
  T ? (t.delete(e), e(0)) : (t.add(e), v());
}

function v() {
  l < 0 && (l = 0, n.frameLoop !== "demand" && y(b));
}

function R() {
  l = -1;
}

function b() {
  ~l && (y(b), n.batchedUpdates(x));
}

function x() {
  var e = l;
  l = n.now();
  var t = w(l);

  if (t && (Q(i.splice(0, t), function (a) {
    return a.handler();
  }), u -= t), !u) {
    R();
    return;
  }

  d.flush(), f.flush(e ? Math.min(64, l - e) : 16.667), h.flush(), m.flush(), p.flush();
}

function r() {
  var e = new Set(),
      t = e;
  return {
    add: function add(a) {
      u += t == e && !e.has(a) ? 1 : 0, e.add(a);
    },
    delete: function _delete(a) {
      return u -= t == e && e.has(a) ? 1 : 0, e.delete(a);
    },
    flush: function flush(a) {
      t.size && (e = new Set(), u -= t.size, Q(t, function (o) {
        return o(a) && e.add(o);
      }), u += e.size, t = e);
    }
  };
}

function Q(e, t) {
  e.forEach(function (a) {
    try {
      t(a);
    } catch (o) {
      n.catch(o);
    }
  });
}

var S = {
  count: function count() {
    return u;
  },
  isRunning: function isRunning() {
    return l >= 0;
  },
  clear: function clear() {
    l = -1, i = [], d = r(), f = r(), h = r(), m = r(), p = r(), u = 0;
  }
};
export { S as __raf, n as raf };